import React from 'react'
import {IGame, IScoreboardContentBlock} from "@webng-types/write-model";
import Scoreboard from "../scoreboard/Scoreboard";


export function ScoreboardContentBlockView({block, game}: {block: IScoreboardContentBlock, game: IGame}){
  return block.scoreboard ? <Scoreboard scoreboard={block.scoreboard}/> : <></>;
}
